import { InjectionToken } from '@angular/core';

export const TRANSLATION_PRISMIC_TAG = new InjectionToken<string>('TRANSLATION_PRISMIC_TAG');

export type TranslationDynamicValues = { [key: string]: string };

export const TRANSLATION_DYNAMIC_VALUES = new InjectionToken<TranslationDynamicValues>('TRANSLATION_DYNAMIC_VALUES');
